// extracted by mini-css-extract-plugin
module.exports = {"salesPeriodContainer":"VIP_SalesPeriod__salesPeriodContainer","salesPeriodText":"VIP_SalesPeriod__salesPeriodText"};